/*-----------------------------------------------------------------------------
|> IPTV schedule timeline Component
|------------------------------------------------------------------------------
|
| Render schedule time bar
|
-----------------------------------------------------------------------------*/
<template>
    <div class="guide-schedule-timeline">
        <div class="airing-title-current">
            <p>{{ programTitle }}</p>
        </div>

        <div class="schedule-timeline-current">
            <span>Live</span>
            <span>{{ currentTime.format('hh:mm A') }}</span>
        </div>

        <div ref="scheduleTimeline" class="schedule-timeline">
            <span
                v-for="(time, index) in scheduleTimebar"
                :key="index"
                class="schedule-timeline-item"
                :style="{ minWidth: `${timebarItemWidth}px!important` }"
            >
                {{ time.format('hh:mm A') }}
            </span>
        </div>
    </div>
</template>

<script>

const SCROLL_DIRECTION_LEFT = 2;
const SCROLL_DIRECTION_RIGHT = 4;

export default {
    props: {
        currentTime: { type: Object, required: true },
        programTitle: { type: String, required: true },
    },
    data() {
        return {
            swipeDelta: 0,
        }
    },
    computed: {
        /**
         * Returns an array of datetime(dayjs) instances one hour apart from each
         *  other. Starting at the `currentAiring` start time.
         */
        scheduleTimebar() {
            let nextTimeSegment = this.currentTime.startOf('hour');
            let timebar = [ nextTimeSegment ];

            for (let i = 1; i < this.$root.timebarItemCount; i++) {
                nextTimeSegment = nextTimeSegment
                    .add(this.$root.timebarItemLength, 'minutes');
                timebar.push(nextTimeSegment);
            }

            return timebar;
        },
        /**
         * Horizontal pixel dimension(width) of individual timebar items/segments
         */
        timebarItemWidth() {
            return 150;
            // return (window.visualViewport.width - this.$root.channelColumnWidth) / this.$root.timebarItemCount;
        },
    },
    mounted() {
        this.$refs.scheduleTimeline.addEventListener('touchstart', this.handleTouchStart, false);
        this.$refs.scheduleTimeline.addEventListener('touchend', this.handleTouchEnd, false);
    },
    methods: {
        handleTouchStart(evt) {
            this.touchStartX = evt.touches[0].clientX;
            this.touchStartY = evt.touches[0].clientY;
        },
        handleTouchEnd(evt) {
            const deltaX = evt.changedTouches[0].clientX - this.touchStartX;
            const deltaY = evt.changedTouches[0].clientY - this.touchStartY;

            if (Math.abs(deltaX) > Math.abs(deltaY)) { // horizontal scroll
                if (deltaX > 0) {
                    this.$emit('swiped', {
                        raw: evt,
                        direction: SCROLL_DIRECTION_RIGHT,
                        distance: Math.abs(deltaX),
                    });

                } else {
                    this.$emit('swiped', {
                        raw: evt,
                        direction: SCROLL_DIRECTION_LEFT,
                        distance: Math.abs(deltaX),
                    });
                }
            }
        },
    },
}
</script>
